/**
 * Returns true when `pathname` is a route that should remain viewable by
 * unauthenticated users even on a single-tenant host (e.g. enterprise.perplexity.ai).
 *
 * PR 6 added a blanket "redirect to /auth/signin" for any unauthenticated visitor
 * to a single-tenant host. The PRD also requires that non-enterprise users can
 * still open shared Threads / Pages / Spaces links pointing at the enterprise
 * subdomain — so those content-share paths need to bypass the gate.
 *
 * Backend share-authorization still applies: if the underlying content isn't
 * actually publicly shared, the page renders the standard "not authorized"
 * state. This helper only decides whether the *frontend redirect* fires.
 *
 * /search/new and its subpaths are explicitly excluded — those start a NEW
 * query (anon querying is the thing the single-tenant gate exists to block).
 */
const PUBLIC_SHARED_CONTENT_PREFIXES = [
    '/search/',
    '/page/',
    '/canonical-page',
    '/projects/',
    '/spaces/',
    '/discover',
];
export const isPublicSharedContentPath = (pathname) => {
    if (pathname === '/search/new' || pathname.startsWith('/search/new/')) {
        return false;
    }
    return PUBLIC_SHARED_CONTENT_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
//# sourceMappingURL=singleTenantPublicPaths.js.map